import { useProfileContext } from '@/features/context/ProfileContext';
import { selfEmployedLegalForms, TLegalFormKey, UserTypes } from '@/features/user/store/user.model';

import { PhysicalUser } from './physicalUser';
import { BusinessUser } from './businessUser';
import { SelfEmployedUser } from './selfEmployedUser';

export function UserInformation() {
  const { user } = useProfileContext();
  const isSelfEmployed = selfEmployedLegalForms.includes(Number(user?.legalForm) as TLegalFormKey);

  return (
    <>
      {user.userTypeId === UserTypes.naturalPerson &&
        (isSelfEmployed ? <SelfEmployedUser user={user} /> : <PhysicalUser user={user} />)}
      {user.userTypeId === UserTypes.business && <BusinessUser user={user} />}
    </>
  );
}
